import { render, staticRenderFns } from "./BaseMonitor.vue?vue&type=template&id=55de0dd7"
import script from "./BaseMonitor.vue?vue&type=script&lang=js"
export * from "./BaseMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports